import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../../../config/theme';
import { getLanguage, setLanguage, Language } from '../../../../../config/locale';

const Toggle = styled.div`
    display: flex;
    align-items: center;
    height: 34px;
    padding: 3px;
    margin-right: 14px;
    border: 1px solid ${(props: any) => props.theme[COLORS.BORDER]};
    border-radius: 17px;
    white-space: nowrap;

    .language {
        height: 26px;
        padding: 0 11px;
        border: 0;
        border-radius: 13px;
        background: transparent;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.4px;
        color: ${(props: any) => props.theme[COLORS.PLACEHOLDER]};
        cursor: pointer;

        &:hover {
            color: ${(props: any) => props.theme[COLORS.PRIMARY]};
        }

        &.active {
            background: ${(props: any) => props.theme[COLORS.PRIMARY]};
            color: ${(props: any) => props.theme[COLORS.POP_UP]};
            cursor: default;
        }

        &.active:hover {
            color: ${(props: any) => props.theme[COLORS.POP_UP]};
        }
    }
`;

/**
 * The language this session renders in, switchable from every screen.
 *
 * The installation picks the opening language — DRC opens in French — but the
 * choice has to be reversible in one click and from wherever the reader
 * happens to be. Bank staff in either country may prefer the other language,
 * and a demo audience will want to see the same screen both ways without
 * being walked to a settings page to do it.
 *
 * `EN` and `FR` are deliberately not translated. A control for changing
 * language is the one thing on screen that must stay legible to someone who
 * cannot read the current language, so it is labelled the same in both.
 */
const LANGUAGES: Language[] = ['en', 'fr'];

const LanguageToggle = () => {
    const current = getLanguage();

    return (
        <Toggle role="group" aria-label="Language">
            {LANGUAGES.map((language) => (
                <button
                    key={language}
                    type="button"
                    // Re-selecting the current language would reload the page to
                    // arrive exactly where it started, so it does nothing.
                    onClick={() => language !== current && setLanguage(language)}
                    className={language === current ? 'language active' : 'language'}
                    aria-pressed={language === current}
                >
                    {language.toUpperCase()}
                </button>
            ))}
        </Toggle>
    );
};

export default LanguageToggle;
